import React, { forwardRef } from "react";

import { DotLoaderProps } from "./DotLoader.types";
import { StyledDotLoader } from "./DotLoader.styles";

const DotLoader = forwardRef<HTMLDivElement, DotLoaderProps>(
    (props: DotLoaderProps, ref) => {
        return <StyledDotLoader {...props} />;
    },
);

export default DotLoader;
